import { fetchItemLicenses } from './searchPage'
import { fetchSimilarItems } from './fetchSimilarItems'

export const closeModal = () => {
  return {
    type: 'closeModal'
  }
}

export const openModal = data => {
  return {
    type: 'openModal',
    payload: data
  }
}

export const showModalMessage = data => {
  return {
    type: 'showModalMessage',
    payload: data
  }
}

export const dismissModalMessage = () => {
  return {
    type: 'dismissModalMessage'
  }
}

export const toggleOffCanvas = direction => {
  return {
    type: 'toggleOffCanvas',
    payload: direction
  }
}

export const togglePanel = panelId => {
  return {
    type: 'togglePanel',
    payload: panelId
  }
}

export const toggleSidebar = () => {
  return {
    type: 'toggleSidebar'
  }
}

export const selectItem = itemId => {
  return (dispatch, getState) => {
    dispatch(fetchItemLicenses(itemId))
    dispatch(fetchSimilarItems(itemId))
    return dispatch(selectItemAction(itemId))
  }
}

export const selectItemAction = itemId => {
  return {
    type: 'selectItem',
    payload: itemId
  }
}

export const setOffsetTop = offsetTop => {
  return {
    type: 'offsetTop',
    payload: { offsetTop }
  }
}



// WEBPACK FOOTER //
// ./common/actions/layout.js